import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { RuleCombinator } from '../../types/rule';

export const ConditionCombinator = ({
  type,
  className,
}: {
  type: RuleCombinator;
  className?: string;
}) => {
  const { t } = useTranslation('crm');
  return (
    <div
      className={classNames(
        'flex h-12 w-12 items-center justify-center text-sm font-semibold',
        className,
        {
          'bg-warning/20': type === RuleCombinator.IF,
          'bg-[#F1E6FF]': type === RuleCombinator.OR,
          'bg-[#DBF6E4]': type === RuleCombinator.AND,
        }
      )}
    >
      {t('crm.conditionBuilder.combinator', { type })}
    </div>
  );
};
